export const formatRecordDate = (
  startValue,
  endValue,
  timezone,
  dateOptions,
  timeOptions
) => {
  if (!startValue) return ''
  const startDate = new Date(startValue)
  const endDate = endValue ? new Date(endValue) : null
  if (Number.isNaN(startDate.getTime())) {
    return String(startValue)
  }

  const datePart = new Intl.DateTimeFormat('ru-RU', dateOptions).format(
    startDate
  )
  const startTime = new Intl.DateTimeFormat('ru-RU', timeOptions).format(
    startDate
  )

  if (!endDate || Number.isNaN(endDate.getTime())) {
    return `${datePart} ${startTime}`
  }

  const endTime = new Intl.DateTimeFormat('ru-RU', timeOptions).format(endDate)

  return `${datePart} ${startTime}-${endTime}`
}
